/**
 * Card action presets — shared click handlers for section cards.
 */
(function () {
  if (window._cardActionsLoaded) {
    return;
  }
  window._cardActionsLoaded = true;

const LIVE_CHAT_AUTO_OPEN_KEY = 'ml-open-live-chat';
const LIVE_CHAT_AUTO_OPEN_PARAM = 'open_live_chat';

let autoOpenLiveChatScheduled = false;

const cardActionHandlers = {
  live_chat_shulex(event, context) {
    event.preventDefault();

    const trigger = event.target.closest('[data-action-preset]');
    trigger?.blur?.();

    if (!context.isCustomerLoggedIn) {
      redirectToLogin(context.loginUrl, { openLiveChatAfterReturn: true });
      return;
    }

    openLydaasLiveChat();
  },
};

function getActionContext(element) {
  const root = element.closest('multiple-link, icon-cards');

  return {
    isCustomerLoggedIn: root?.dataset.customerLoggedIn === 'true',
    loginUrl: root?.dataset.loginUrl || '',
  };
}

function markOpenLiveChatIntent() {
  try {
    sessionStorage.setItem(LIVE_CHAT_AUTO_OPEN_KEY, '1');
  } catch (error) {
    // Ignore storage errors in restricted browsing modes.
  }
}

function appendLiveChatReturnParam(returnUrl) {
  const url = new URL(returnUrl, window.location.origin);
  url.searchParams.set(LIVE_CHAT_AUTO_OPEN_PARAM, '1');
  return `${url.pathname}${url.search}${url.hash}`;
}

function hasOpenLiveChatIntent() {
  try {
    if (sessionStorage.getItem(LIVE_CHAT_AUTO_OPEN_KEY) === '1') {
      return true;
    }
  } catch (error) {
    // Fall through to URL param check.
  }

  return new URLSearchParams(window.location.search).get(LIVE_CHAT_AUTO_OPEN_PARAM) === '1';
}

function clearOpenLiveChatIntent() {
  try {
    sessionStorage.removeItem(LIVE_CHAT_AUTO_OPEN_KEY);
  } catch (error) {
    // Ignore storage errors in restricted browsing modes.
  }

  const url = new URL(window.location.href);
  if (!url.searchParams.has(LIVE_CHAT_AUTO_OPEN_PARAM)) {
    return;
  }

  url.searchParams.delete(LIVE_CHAT_AUTO_OPEN_PARAM);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

function isCustomerLoggedInOnPage() {
  return (
    document.querySelector('multiple-link[data-customer-logged-in="true"]') !== null ||
    document.querySelector('icon-cards[data-customer-logged-in="true"]') !== null
  );
}

function redirectToLogin(loginUrlValue, { openLiveChatAfterReturn = false } = {}) {
  if (!loginUrlValue) {
    return;
  }

  const loginUrl = new URL(loginUrlValue, window.location.origin);
  let returnUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (window.location.pathname === loginUrl.pathname) {
    return;
  }

  if (openLiveChatAfterReturn) {
    markOpenLiveChatIntent();
    returnUrl = appendLiveChatReturnParam(returnUrl);
  }

  loginUrl.searchParams.set('return_url', returnUrl);
  window.location.assign(loginUrl.toString());
}

/**
 * @returns {boolean}
 */
function openLydaasLiveChat() {
  if (!window.LydaasChat || typeof window.LydaasChat.open !== 'function') {
    return false;
  }

  return window.LydaasChat.open() === true;
}

/**
 * The chat element boots from a deferred script. Wait until it can open.
 * @returns {Promise<boolean>}
 */
function waitForLydaasLiveChat() {
  return new Promise((resolve) => {
    if (openLydaasLiveChat()) {
      resolve(true);
      return;
    }

    const started = performance.now();
    const timer = window.setInterval(() => {
      if (openLydaasLiveChat()) {
        window.clearInterval(timer);
        resolve(true);
        return;
      }

      if (performance.now() - started > 5000) {
        window.clearInterval(timer);
        resolve(false);
      }
    }, 200);
  });
}

async function tryAutoOpenLiveChat() {
  if (!isCustomerLoggedInOnPage() || !hasOpenLiveChatIntent()) {
    return;
  }

  const opened = await waitForLydaasLiveChat();
  if (opened) {
    clearOpenLiveChatIntent();
  }
}

function handleCardActionClick(event) {
  const trigger = event.target.closest('[data-action-preset]');
  if (!trigger) {
    return;
  }

  const preset = trigger.dataset.actionPreset;
  const handler = cardActionHandlers[preset];
  if (!handler) {
    return;
  }

  handler(event, getActionContext(trigger));
}

document.addEventListener('click', handleCardActionClick);

function scheduleAutoOpenLiveChat() {
  if (autoOpenLiveChatScheduled || !hasOpenLiveChatIntent()) {
    return;
  }

  autoOpenLiveChatScheduled = true;

  const run = () => {
    tryAutoOpenLiveChat();
  };

  if (document.readyState === 'complete') {
    run();
    return;
  }

  window.addEventListener('load', run, { once: true });
}

scheduleAutoOpenLiveChat();
})();
